<div class="text-center">
  <p>404</p>
  <div>{{ 'error.404' | translate }}</div>
  <button class="btn btn--primary" [routerLink]="currentRoute.pathSlash">
    {{ 'action.back_to_station_list' | translate }}
  </button>
</div>
